/* =========================================================
   TOTAL FOOTY CO — GLOBAL JS
   No framework, no build step. Progressive enhancement only.
   ========================================================= */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function trapFocus(container) {
    var focusable = qsa('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusable.length) return;
    focusable[0].focus();
  }

  /* ---------- Drawers (cart / search / mobile menu) ---------- */
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    var overlay = qs('[data-drawer-overlay="' + id + '"]') || qs(".drawer__overlay");
    drawer.setAttribute("data-state", "open");
    if (overlay) overlay.setAttribute("data-state", "open");
    document.body.style.overflow = "hidden";
    drawer.setAttribute("aria-hidden", "false");
    trapFocus(drawer);
  }

  function closeDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    var overlay = qs('[data-drawer-overlay="' + id + '"]') || qs(".drawer__overlay");
    drawer.setAttribute("data-state", "closed");
    if (overlay) overlay.setAttribute("data-state", "closed");
    document.body.style.overflow = "";
    drawer.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("click", function (e) {
    var openTrigger = e.target.closest("[data-open-drawer]");
    if (openTrigger) {
      e.preventDefault();
      openDrawer(openTrigger.getAttribute("data-open-drawer"));
      return;
    }
    var closeTrigger = e.target.closest("[data-close-drawer]");
    if (closeTrigger) {
      e.preventDefault();
      closeDrawer(closeTrigger.getAttribute("data-close-drawer"));
      return;
    }
    var overlay = e.target.closest(".drawer__overlay");
    if (overlay) {
      qsa('.drawer[data-state="open"]').forEach(function (d) { closeDrawer(d.id); });
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      qsa('.drawer[data-state="open"]').forEach(function (d) { closeDrawer(d.id); });
    }
  });

  /* ---------- Accordion (materials / tech / shipping / FAQ) ---------- */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(".accordion__trigger");
    if (!trigger) return;
    var expanded = trigger.getAttribute("aria-expanded") === "true";
    var panel = document.getElementById(trigger.getAttribute("aria-controls"));
    var closeSiblings = trigger.closest(".accordion").hasAttribute("data-single-open");

    if (closeSiblings) {
      qsa(".accordion__trigger", trigger.closest(".accordion")).forEach(function (t) {
        if (t !== trigger) {
          t.setAttribute("aria-expanded", "false");
          var p = document.getElementById(t.getAttribute("aria-controls"));
          if (p) p.setAttribute("data-open", "false");
        }
      });
    }

    trigger.setAttribute("aria-expanded", String(!expanded));
    if (panel) panel.setAttribute("data-open", String(!expanded));
  });

  /* ---------- Scroll reveal ---------- */
  var revealItems = qsa("[data-reveal]");
  if (revealItems.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealItems.forEach(function (el) { io.observe(el); });
  } else {
    revealItems.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Sticky add-to-cart visibility ---------- */
  var mainAtc = qs("[data-main-add-to-cart]");
  var stickyAtc = qs("[data-sticky-add-to-cart]");
  if (mainAtc && stickyAtc && "IntersectionObserver" in window) {
    var atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyAtc.setAttribute("data-visible", String(!entry.isIntersecting));
        });
      },
      { threshold: 0 }
    );
    atcObserver.observe(mainAtc);
  }

  /* ---------- Sticky add-to-cart submit trigger ---------- */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-sticky-atc-submit]");
    if (!trigger) return;
    var mainForm = document.querySelector("[data-main-add-to-cart]");
    if (mainForm && typeof mainForm.requestSubmit === "function") {
      mainForm.requestSubmit();
    } else if (mainForm) {
      mainForm.submit();
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quantity-step]");
    if (!btn) return;
    var wrapper = btn.closest("[data-quantity-wrapper]");
    var input = wrapper && wrapper.querySelector("input[type='number']");
    if (!input) return;
    var step = parseInt(btn.getAttribute("data-quantity-step"), 10);
    var min = parseInt(input.min || "1", 10);
    var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = value;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Cart (AJAX) ---------- */
  var cartDrawerId = "CartDrawer";
  var cartSectionIds = "cart-drawer,main-cart";

  function updateCartCount(count) {
    qsa("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* Swaps a fragment of the DOM with the freshly rendered version returned
     by Shopify's dynamic section-rendering endpoint, preserving open/closed
     drawer state. This keeps the cart drawer AND the full cart page in sync
     after any add / remove / quantity change, without a full page reload. */
  function swapFragment(sectionHtml, selector) {
    if (!sectionHtml) return;
    var temp = document.createElement("div");
    temp.innerHTML = sectionHtml;
    var newEl = temp.querySelector(selector);
    var oldEl = document.querySelector(selector);
    if (!newEl || !oldEl) return;
    if (oldEl.hasAttribute("data-state")) {
      newEl.setAttribute("data-state", oldEl.getAttribute("data-state"));
      newEl.setAttribute("aria-hidden", oldEl.getAttribute("aria-hidden") || "true");
    }
    oldEl.replaceWith(newEl);
  }

  function refreshCartFragments() {
    return fetch("/?sections=" + cartSectionIds)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data["cart-drawer"]) {
          swapFragment(data["cart-drawer"], "#" + cartDrawerId);
          swapFragment(data["cart-drawer"], '[data-drawer-overlay="' + cartDrawerId + '"]');
        }
        if (data["main-cart"] && document.querySelector("[data-cart-page]")) {
          swapFragment(data["main-cart"], "[data-cart-page]");
        }
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      })
      .catch(function () {});
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute("disabled", "disabled");

    fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        if (result.status) { throw new Error(result.description || "Could not add to cart"); }
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var themeSettings = window.theme || {};
        if (themeSettings.cartType === "page") {
          window.location.href = "/cart";
        } else {
          refreshCartFragments().then(function () { openDrawer(cartDrawerId); });
        }
      })
      .catch(function () {
        window.location.href = "/cart";
      })
      .finally(function () {
        if (submitBtn) submitBtn.removeAttribute("disabled");
      });
  });

  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-cart-remove]");
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute("data-cart-remove");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartFragments();
      });
  });

  /* ---------- Cart line quantity change (drawer + page) ---------- */
  var quantityDebounce = null;
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-quantity-input]");
    if (!input) return;
    var key = input.getAttribute("data-key");
    if (!key) return;
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);

    clearTimeout(quantityDebounce);
    quantityDebounce = setTimeout(function () {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartFragments();
        });
    }, 400);
  });

  /* ---------- Header shadow on scroll ---------- */
  var header = qs(".header");
  if (header) {
    var lastScroll = 0;
    window.addEventListener(
      "scroll",
      function () {
        var y = window.scrollY;
        header.setAttribute("data-scrolled", String(y > 8));
        lastScroll = y;
      },
      { passive: true }
    );
  }
})();
